import React from "react";
import {
  ListItem as MuiListItem,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import clsx from "clsx";
const ITEM_HEIGHT = 40;
export const MenuLink = ({ to, label, active, onClick }) => {
  const classes = useStyles();
  return (
    <Link to={to} className={classes.link} onClick={onClick}>
      <MuiListItem
        button
        className={clsx(classes.item, active && classes.activeItem)}
      >
        <Typography noWrap className={classes.itemText}>
          {label}
        </Typography>
      </MuiListItem>
    </Link>
  );
};

export const useStyles = makeStyles(
  (theme) => ({
    // Above page content and drawers (e.g. the Report page), below modals.
    popper: {
      zIndex: theme.zIndex.drawer + 50,
    },
    paper: {
      width: 220,
      marginTop: 2,
      overflow: "hidden",
    },
    dashboards: {
      overflowY: "auto",
    },
    link: {
      display: "block",
      textDecoration: "none !important",
    },
    item: {
      height: ITEM_HEIGHT,
      paddingInline: theme.spacing(1.5),
    },
    itemText: {
      color: theme.palette.black["60"],
      fontSize: 14,
    },
    activeItem: {
      backgroundColor: theme.palette.main["10"],
      "& $itemText": {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    empty: {
      height: ITEM_HEIGHT,
      lineHeight: `${ITEM_HEIGHT}px`,
      paddingInline: theme.spacing(1.5),
      color: theme.palette.black["40"],
      fontSize: 13,
      fontStyle: "italic",
    },
  }),
  { name: "HeaderSubmenu" }
);
